import {
    Component, Input, ViewChild, ViewEncapsulation, Injector,
    Output, EventEmitter
}                                                  from '@angular/core';
import {NG_VALUE_ACCESSOR, FormControl, FormGroup} from '@angular/forms';
import {OnChange}                                  from '@ng-app-framework/core';
import {Observable}                                from 'rxjs/Rx';
import {FormConfig}                                from '../../Service/FormConfig';
import {NgFormControl}                             from '../NgFormControl';

@Component({
    selector     : 'text-box',
    template     : `
        <ng-container *ngIf="initialized">
            <div class="form-group" [class.validate-input]="shouldValidate" [class.no-validate-input]="!shouldValidate">
                <label [attr.for]="identifier" *ngIf="label.length > 0">
                    {{label}}
                    <ng-container *ngIf="required && config.showRequiredAsterisk">*</ng-container>
                </label>
                <div></div>
                <div class="input-group ng-control" (click)="click.emit()"
                     [ngClass]="{'ng-invalid':(isInvalid$() | async), 'ng-touched':(touched$ | async), 'ng-valid':!(isInvalid$() | async)}">
                    <ng-content select=".input-group-prepend"></ng-content>
                    <input class="form-control" [type]="type" #input
                           (focus)="inputFocus.emit()"
                           [placeholder]="placeholder || ''"
                           [id]="identifier"
                           [attr.name]="name"
                           [name]="name"
                           [attr.role]="disableLastPass ? 'note' : ''"
                           [attr.autocomplete]="autocomplete ? autocomplete : disableLastPass ? 'off' : name"
                           [disabled]="disabled"
                           [(ngModel)]="value"
                           (blur)="triggerValidation()"
                           [attr.autofocus]="autofocus || null"
                           [attr.autocapitalize]="autocapitalize"
                           [attr.autocorrect]="autocorrect"
                           [attr.spellcheck]="spellcheck"
                           [attr.data-lpignore]="disableLastPass || null"
                           tabindex="0"
                    />
                    <ng-content select=".input-group-append"></ng-content>
                </div>
                <validation-messages *ngIf="(isInvalid$() | async) && showErrors" [errors]="failures" [label]="label">
                </validation-messages>
            </div>
        </ng-container>
    `,
    styles: [`check-box,date-picker,email,nested-check-box,nested-list{display:block;position:relative}.validation-messages{margin-top:10px}.form-group .form-control.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.form-group .alert-danger ul{margin-bottom:0}.form-group .form-control{width:auto}.form-group .input-group{width:auto;white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;border-radius:.25em;border:1px solid #ccc;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.form-group .input-group .form-control{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;border-top-left-radius:0;border-bottom-left-radius:0;border:none;white-space:normal}.form-group .input-group input.form-control:first-child{border-top-left-radius:.25em;border-bottom-left-radius:.25em}.form-group .input-group .input-group-text{border-style:none;border-radius:0 .25em .25em 0}.form-group .input-group .input-group-append,.form-group .input-group .input-group-prepend{border-top:none;border-bottom:none}.form-group .input-group .input-group-append:first-child,.form-group .input-group .input-group-prepend:first-child{border-bottom:none;border-left:none;border-right:1px solid #ccc}.form-group .input-group .input-group-prepend .input-group-text{border-radius:0}.form-group .input-group.full-width .input-group-append,.form-group .input-group.full-width .input-group-prepend{width:100%}.form-group .input-group.full-width .form-control,.form-group .input-group.full-width .ng-control,.form-group .input-group.full-width .ng-select{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.form-group .input-group .input-group-prepend+.ng-select{margin-left:1px}.form-group .form-control label{margin-bottom:0;line-height:24px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.form-group .d-flex>radio{margin-right:10px}.form-group .d-flex>radio:last-child{margin-right:0}.validate-input .input-group .ng-control,.validate-input .input-group.ng-control,.validate-input .ng-control,.validate-input.ng-control{border:1px solid #ccc;border-left:5px solid #ccc}.validate-input .input-group .ng-control.ng-valid:not(form).ng-touched,.validate-input .input-group.ng-control.ng-valid:not(form).ng-touched,.validate-input .ng-control.ng-valid:not(form).ng-touched,.validate-input.ng-control.ng-valid:not(form).ng-touched{border-left:5px solid #42a948}.validate-input .input-group .ng-control.ng-invalid:not(form).ng-touched,.validate-input .input-group.ng-control.ng-invalid:not(form).ng-touched,.validate-input .ng-control.ng-invalid:not(form).ng-touched,.validate-input.ng-control.ng-invalid:not(form).ng-touched{border-left:5px solid #a94442}.validate-input .input-group .ng-control .ng-control,.validate-input .input-group.ng-control .ng-control,.validate-input .ng-control .ng-control,.validate-input.ng-control .ng-control{border:none}.validate-input .input-group .no-validate-input .input-group,.validate-input .no-validate-input .input-group{border:1px solid #ccc}.validate-input .input-group .no-validate-input .input-group.ng-invalid:not(form).ng-touched,.validate-input .input-group .no-validate-input .input-group.ng-valid:not(form).ng-touched,.validate-input .no-validate-input .input-group.ng-invalid:not(form).ng-touched,.validate-input .no-validate-input .input-group.ng-valid:not(form).ng-touched{border-left:1px solid #ccc}.validate-input .input-group .no-validate-input .input-group .ng-control,.validate-input .no-validate-input .input-group .ng-control{border:none}.validate-input .form-control-container>.ng-control,.validate-input .input-group .form-control-container>.ng-control{border:1px solid #ccc;border-left:5px solid #ccc}.validate-input .form-control-container.ng-valid:not(form).ng-touched>.ng-control,.validate-input .input-group .form-control-container.ng-valid:not(form).ng-touched>.ng-control{border-left:5px solid #42a948}.validate-input .form-control-container.ng-invalid:not(form).ng-touched>.ng-control,.validate-input .input-group .form-control-container.ng-invalid:not(form).ng-touched>.ng-control{border-left:5px solid #a94442}.full-width .form-group .form-control,.full-width .form-group .input-group{width:100%}.full-width .form-group .input-group .form-control,.full-width .form-group .ng-select{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}`],
    providers    : [{
        provide    : NG_VALUE_ACCESSOR,
        useExisting: TextBoxComponent,
        multi      : true
    }],
    encapsulation: ViewEncapsulation.None
})
export class TextBoxComponent extends NgFormControl<string> {

    @Input() name: string                = null;
    @OnChange @Input() required: boolean = false;
    @OnChange @Input() disabled: boolean = false;
    @Input() parentFormControl: FormControl;
    @Input() parentFormGroup: FormGroup;
    @Input() label: string               = '';
    @Input() placeholder: string         = null;
    @Input() shouldValidate              = true;
    @Input() showErrors                  = true;
    @Input() autocomplete                = null;
    @Output() click                      = new EventEmitter<any>();
    @Output() inputClick                 = new EventEmitter<any>();
    @Output() inputFocusOut              = new EventEmitter<any>();
    @Output() inputFocus                 = new EventEmitter<any>();

    @Input() disableLastPass = false;


    @Input() type: string   = 'text';
    @Input() autofocus      = null;
    @Input() autocorrect    = true;
    @Input() autocapitalize = true;
    @Input() spellcheck     = true;

    @Input() format: { regex: RegExp | RegExp[], replacement: string | Function };

    @ViewChild('input') input;

    protected identifier = `text-box-${identifier++}`;

    constructor(public injector: Injector, public config: FormConfig) {
        super(injector);
    }

    onLoad() {
        if (!this.input || !this.input.nativeElement) {
            setTimeout(() => this.onLoad(), 500);
            return;
        }
        Observable.fromEvent(this.input.nativeElement, 'keydown')
                  .takeUntil(this.onDestroy$)
                  .subscribe((event: KeyboardEvent) => {
                      if (event.key === 'Tab') {
                          this.triggerValidation();
                      }
                  });
        if (this.autofocus) {
            this.input.nativeElement.focus();
        }
    }

    protected triggerValidation() {
        super.triggerValidation();
        this.inputFocusOut.emit();
    }
}

let identifier = 0;
